import { TransactionItem } from 'src/app/models/transaction-item.model';
import { TransactionFlow } from './../../enums/transaction-flow.enum';
import { Transaction } from './../../models/transaction.model';

export const checkIfTransactionIsPositive = (
  transactionData: Transaction | TransactionItem | null
): boolean => {
  return transactionData?.flow === TransactionFlow.Incoming ? true : false;
};
